
import { PJAxios, PJLinkSalto, sendLogin, usePJStore, useProfile, useUserInfo } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../api/ChatbotApi';
import './GestioneConfigurazioni.css';


function GestioneConfigurazioni(props) {

  const [loadTematiche, setLoadTematiche] = useState(false);
  const [tematiche, setTematiche] = useState(null);
  const [createConfigurazione, setCreateConfigurazione] = useState(null);
  const [createConfigurazioneVisible, setCreateConfigurazioneVisible] = useState(false);
  const [inputNomeObj, setInputNomeObj] = useState(null);
  const [inputResponsabileObj, setInputResponsabileObj] = useState(null);
  const [selectGruppoVisObj, setSelectGruppoVisObj] = useState(null);
  const [selectAccessoObj, setSelectAccessoObj] = useState(null);

  const [saltoAccesso, setSaltoAccesso] = useState(null)
  const [currentProfile, setCurrentProfile] = useState(null)

  const { storage } = usePJStore((state) => state.storage)

  const isLogged = useUserInfo() != null;


  const getText = usePJStore((state) => state.i18n_getText)

  const params = usePJStore((state) => state.params)

  const profile = useProfile();

  const saltoResponsabile = params.lookup_id_persona;
  const saltoNome = params.nome;
  const saltoGruppoVis = params.gruppoVis;
  var strAccesso = params.accesso;

  const dbTest = usePJStore((state) => state.appInfo_dbTest);

  const arrGruppoVis = [
    { displayName: '--', name: 'DEFAULT' },
    { displayName: 'Servizi', name: 'SERVIZI' },
    { displayName: 'Helpdesk', name: 'HELPDESK' }
  ];

  useEffect(() => {
    //console.log("profile", profile)
    PJAxios().post('/gestioneConfigurazioni/elencoConfigurazioni', { refresh: true }).then((res) => {
      setTematiche(res.data);
      setCreateConfigurazioneVisible(false);

      if (saltoResponsabile != null && saltoResponsabile != "") {
        nuovaConfigurazione();
      }
      setLoadTematiche(false)
      setCurrentProfile(profile)
    });

  }, [JSON.stringify(profile)]);

  useEffect(() => {
    if (!isLogged) {
      sendLogin()
    }
    if (strAccesso != null && strAccesso != "") {
      var arrAccesso = strAccesso.split(",");
      setSaltoAccesso(arrAccesso);
    }

    setLoadTematiche(true)
    document.title = "Configuratore FAQ";
  }, []);

  useEffect(() => {

    if (loadTematiche) {

      PJAxios().post('/gestioneConfigurazioni/elencoConfigurazioni', { refresh: true }).then((res) => {
        setTematiche(res.data);
        setCreateConfigurazioneVisible(false);

        if (saltoResponsabile != null && saltoResponsabile != "") {
          nuovaConfigurazione();
        }
        setLoadTematiche(false)
      });
    }
  }, [loadTematiche]);




  const cancellazioneConfigurazione = (rowData) => {

    PJAxios().post('/gestioneConfigurazioni/removeConfigurazione', { idConfig: rowData.id_config }).then((res) => {
      setTematiche(res.data);
      setCreateConfigurazioneVisible(false);
    });
  }

  const nuovaConfigurazione = () => {

    PJAxios().post('/gestioneConfigurazioni/createConfigurazione', { refresh: true }).then((res) => {
      setCreateConfigurazione(res.data);
      setCreateConfigurazioneVisible(true);

      setInputNomeObj(saltoNome);
      setSelectAccessoObj(saltoAccesso);
      setSelectGruppoVisObj(saltoGruppoVis);
    });
  }

  const salvataggioCreateConfigurazione = () => {

    PJAxios().post('/gestioneConfigurazioni/salvaConfigurazione', { nome: inputNomeObj, gruppo_vis: selectGruppoVisObj, access: selectAccessoObj, responsabile: saltoResponsabile }).then((res) => {
      setTematiche(res.data);
      setCreateConfigurazioneVisible(false);
      flushCache(dbTest);
    });
  }

  const hideCreateConfigurazione = (event) => {
    setCreateConfigurazioneVisible(false);
  }

  const downloadExcel = () => {
    var url = "https://www6.ceda.polimi.it/questionari/rest/report/chatbot"
    if (dbTest) {
      url = "https://webtest61.dmz.polimi.it/questionari/rest/report/chatbot";
    }
    window.open(url, '_blank', 'noreferrer')

  }

  const modificaConfigurazione = (rowData) => {
    sessionStorage.setItem("expandedKeys", JSON.stringify([0]));
    sessionStorage.setItem("selectedNodeKey", 0);
    sessionStorage.setItem("selectedNode", null);
    props.onTematicaSelected(rowData);
  }

  const responsabileTemplate = (rowData) => {
    return (
      <React.Fragment>
        {rowData.effettivo.xindirizzoResponsabile && rowData.effettivo.responsabile} - {rowData.effettivo.xindirizzoResponsabile && rowData.effettivo.xindirizzoResponsabile}
      </React.Fragment>
    );
  }

  const gruppoVisibilitaTemplate = (rowData) => {
    return (
      <React.Fragment>
        {rowData.gruppoVisibilita === 'DEFAULT' ? '--' : rowData.gruppoVisibilita}
      </React.Fragment>
    );
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <div className="formgroup-inline col-12 md:col-12">
          <div className={(rowData.id_config == 48 || rowData.xnodeCount <= 0) ? "col-6 md:col-6" : "col-12 md:col-12"} ><Button size="small" label="Modifica" icon="pi pi-pencil" onClick={() => { modificaConfigurazione(rowData) }} /></div>
          {rowData.xnodeCount <= 0 &&
            <div className="col-6 md:col-6"><Button size="small" className='p-button-danger' label="Cancella" icon="pi pi-trash" onClick={() => { cancellazioneConfigurazione(rowData) }} /></div>
          }
          {rowData.id_config == 48 &&
            <div className="col-6 md:col-6"><Button size="small" className='p-button-success' label="Report Excel" icon="pi pi-file-excel" onClick={() => { downloadExcel() }} /></div>
          }

        </div>
      </React.Fragment>
    );
  }

  const rowClass = (data) => {
    return {
      "centered": data.gruppoVisibilita == 'HELPDESK'
    }
  }

  const doFlushCache = () => {
    flushCache(dbTest);
  }


  return (
    <>

      {profile && profile.profile == 2 &&
        <>


          <div className='Home'>

            <header className='Home-header'>
              {!tematiche && !createConfigurazioneVisible &&
                <ProgressSpinner />
              }

              {tematiche && !createConfigurazioneVisible &&
                <div className="datatable-configurazioni p-fluid grid">
                  <div className=" field col-12 md:col-12">
                    <Card title={getText("ELENCO_TEMATICHE_DISPONIBILI")}>
                      <DataTable
                        rowClassName={rowClass} size="small" value={tematiche} >
                        <Column className="centeredColumn" field="name" header={getText("NOME")}></Column>
                        <Column field={gruppoVisibilitaTemplate} header={getText("GRUPPO_VISIBILITA")}></Column>
                        <Column field="xnodeCount" header={getText("NUMERO_NODI")}></Column>
                        <Column body={responsabileTemplate} header={getText("RESPONSABILE")} exportable={false}></Column>
                        <Column style={{ minWidth: "10em" }} body={actionBodyTemplate} header={getText("AZIONI")} exportable={false}></Column>
                      </DataTable>

                    </Card>
                  </div>
                  <br />
                  <div className="field col-3 md:col-3">
                    <Button icon="pi pi-plus" onClick={() => nuovaConfigurazione()} label={getText("LBL_NUOVA_TEMATICA")}></Button>
                  </div>
                  <div className="field col-3 md:col-3">
                    <Button icon="pi pi-plus" onClick={() => doFlushCache()} label={getText("LBL_FLUSH_CACHE")}></Button>
                  </div>
                </div>
              }
            </header>

            <Dialog visible={createConfigurazioneVisible} style={{ width: '800px' }} header={getText("LBL_NUOVA_TEMATICA")} modal onHide={hideCreateConfigurazione}>
              <div className="confirmation-content">
                <div className="divLeft">
                  <table width="400px;">
                    <tr>
                      <td className="cellaTabella">
                        <div>
                          <label htmlFor="nomeObj">{getText("LBL_NOME")} </label>
                          <InputText id="nomeObj" placeholder={getText("SCRIVI_QUALCOSA")} value={inputNomeObj} onChange={(e) => setInputNomeObj(e.target.value)} />
                        </div>
                      </td>
                    </tr>
                    {createConfigurazioneVisible &&
                      <tr>
                        <td className="cellaTabella">
                          <div>
                            <label htmlFor="accessoObj">{getText("LBL_ACCESSO")} </label>
                            <MultiSelect className="divCombo" id="accessoObj" optionLabel="description" optionValue="value" value={selectAccessoObj} options={createConfigurazione.allDProfiles} onChange={(e) => setSelectAccessoObj(e.value)} maxSelectedLabels={3} />
                            {/*<Dropdown className="divCombo" id="accessoObj" optionLabel="description" optionValue="value" value={selectAccessoObj} options={createConfigurazione.allDProfiles} onChange={(e) => setSelectAccessoObj(e.value)} />*/}
                          </div>
                        </td>
                      </tr>
                    }
                    <tr>
                      <td className="cellaTabella">
                        <div>
                          <label htmlFor="responsabileObj">{getText("LBL_RESPONSABILE")} </label>
                          <InputText id="responsabileObj" placeholder={getText("SCRIVI_QUALCOSA")} value={saltoResponsabile} onChange={(e) => setInputResponsabileObj(e.target.value)} />
                          <PJLinkSalto id_servizio="464" label={getText("LBL_SELEZIONA")} type="button" returnParams={{ nome: inputNomeObj, accesso: selectAccessoObj, gruppoVis: selectGruppoVisObj }}></PJLinkSalto>
                        </div>
                      </td>
                    </tr>
                    {createConfigurazioneVisible &&
                      <tr>
                        <td className="cellaTabella">
                          <div>
                            <label htmlFor="gruppoVisObj">{getText("LBL_GV")} </label>
                            <Dropdown className="divCombo" id="gruppoVisObj" optionLabel="displayName" optionValue="name" value={selectGruppoVisObj} options={arrGruppoVis/*createConfigurazione.gruppoVisibilita*/} onChange={(e) => setSelectGruppoVisObj(e.value)} />
                          </div>
                        </td>
                      </tr>
                    }
                    <tr>
                      <td className="cellaTabellaCenter">
                        <div>
                          {createConfigurazioneVisible && <Button onClick={() => salvataggioCreateConfigurazione()}>Aggiungi tematica</Button>}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </Dialog>

          </div>
        </>
      }
    </>
  )
}

export default GestioneConfigurazioni
